var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"heading-container"},[_c('ui-heading',{attrs:{"tag":"h3","no-top-margin":""}},[_vm._v(" "+_vm._s(_vm.$t("mrz_form_heading"))+" ")]),(_vm.isMrzVerifiedSuccessIcon)?_c('icon',{staticClass:"icon success",attrs:{"name":"check-circle"}}):_c('icon',{staticClass:"icon fail",attrs:{"name":"alert-circle"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }